/* eslint-disable */
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import { Layout, Menu } from "antd";
import "./SideMenu.css";
import { CreditCardOutlined, FileTextOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import logoD from '@/assets/images/home/logo_d.png';
import DataWorkersLogo from '@/assets/images/home/dw_bule.png';
import { useAutoMenuHighlight } from '@/utils/useAutoMenuHighlight';
import { getPathAliasMap } from '@/utils/menuDict';

const { Sider } = Layout;
const SideMenuComponent = forwardRef(({ onMenuSelect, ...props }, ref) => {
    useAutoMenuHighlight();
  const [refreshKey, setRefreshKey] = useState(0);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [preUrl, setPreUrl] = useState('')

  const navigate = useNavigate();
  const location = useLocation();
  const pathAliasMap = getPathAliasMap();

  const handleMenuSelect = ({ key, item }) => {
    const getMenuLabel = (items, targetKey) => {
      const stack = [...items];
      while (stack.length) {
        const menuItem = stack.pop();
        if (menuItem.key === targetKey) return menuItem.label;
        if (menuItem.children) stack.push(...menuItem.children);
      }
      return null;
    };
    const menuLabel = getMenuLabel(selectedItems, key);
    
    if (onMenuSelect && menuLabel) {
      onMenuSelect(menuLabel);
    }
  };
  useEffect(() => {
    setSelectedItems(props.menuItems || []);
  }, [props.menuItems]);

  useImperativeHandle(ref, () => ({
    changeMenu: () => {
      setCollapsed(!collapsed)
    }
  }));

  // 在菜单列表中根据 key 查找菜单项
  const findMenuByKey = (items, targetKey) => {
    for (const item of items) {
      if (item.key === targetKey) {
        return item;
      }
      if (item.children && item.children.length) {
        const found = findMenuByKey(item.children, targetKey);
        if (found) return found;
      }
    }
    return null;
  };

  // 查找父级菜单的 key
  const findParentKey = (items, targetKey, parentKey = null) => {
    for (const item of items) {
      if (item.key === targetKey) {
        return parentKey;
      }
      if (item.children && item.children.length) {
        const found = findParentKey(item.children, targetKey, item.key);
        if (found !== null) return found;
      }
    }
    return null;
  };

  // 根据路径匹配菜单（支持子页面和别名映射）
  const matchMenuByPathname = (pathname, menuList) => {
    if (!menuList || menuList.length === 0) return null;
    
    // 检查路径别名映射（优先级最高）
    const aliasKey = pathAliasMap[pathname];
    if (aliasKey) {
      const menuItem = findMenuByKey(menuList, aliasKey);
      if (menuItem) {
        const parentKey = findParentKey(menuList, aliasKey);
        // console.log(`路径别名映射: ${pathname} -> ${aliasKey}, 父级: ${parentKey}`);
        return {
          key: aliasKey,
          parentKey: parentKey,
          label: menuItem.label
        };
      }
    }
    
    // 前缀匹配别名
    for (const [aliasPath, aliasKey] of Object.entries(pathAliasMap)) {
      if (pathname.startsWith(aliasPath)) {
        const menuItem = findMenuByKey(menuList, aliasKey);
        if (menuItem) {
          const parentKey = findParentKey(menuList, aliasKey);
          // console.log(`路径前缀匹配: ${pathname} -> ${aliasKey}, 父级: ${parentKey}`);
          return {
            key: aliasKey,
            parentKey: parentKey,
            label: menuItem.label
          };
        }
      }
    }
    
    const pathParts = pathname.split('/').filter(p => p);
    
    // 递归查找匹配的菜单
    const findMatch = (items, parentKey = null) => {
      for (const item of items) {
        let itemPath = null;
        
        if (item.route) {
          itemPath = item.route;
        } 
        else if (item.children && item.children.length) {
          if (pathParts[0]) {
            itemPath = `/${pathParts[0]}/${item.key}`;
          } else {
            itemPath = `/${item.key}`;
          }
        }
        else if (item.key) {
          if (pathParts[0]) {
            itemPath = `/${pathParts[0]}/${item.key}`;
          } else {
            itemPath = `/${item.key}`;
          }
        }
        
        if (itemPath) {
          if (pathname === itemPath || (pathname.startsWith(itemPath + '/') && itemPath !== '/')) {
            return {
              key: item.key,
              parentKey: parentKey,
              label: item.label
            };
          }
        }
        
        if (item.children && item.children.length) {
          const found = findMatch(item.children, item.key);
          if (found) return found;
        }
      }
      return null;
    };
    
    return findMatch(menuList);
  };

  // 主路由监听 useEffect
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    
  
    // sessionStorage
    const expectedMenu = sessionStorage.getItem('expectedMenu');
    
    if (expectedMenu) {
      try {
        const menu = JSON.parse(expectedMenu);
        // console.log('使用 sessionStorage 菜单:', menu);
        setSelectedKeys([menu.key]);
        
        // 查找并展开父级菜单
        const findAndOpenParent = (items, targetKey, parentKey = null) => {
          for (const item of items) {
            if (item.key === targetKey) {
              if (parentKey) {
                setOpenKeys([parentKey]);
              }
              return true;
            }
            if (item.children && item.children.length) {
              if (findAndOpenParent(item.children, targetKey, item.key)) {
                return true;
              }
            }
          }
          return false;
        };
        
        findAndOpenParent(selectedItems, menu.key);
        
        // 更新 TopHeader
        if (onMenuSelect && menu.label) {
           onMenuSelect(menu.label);}
        
        // sessionStorage.removeItem('expectedMenu');
        setRefreshKey(+new Date());
        return;
      } catch (e) {
    
      }
    }
    if (!selectedItems || selectedItems.length === 0) {
      return;
    }
    
    // 使用匹配函数
    const HOME_TITLE = "Home";
    const currentPath = location.pathname.split('?')[0];
    // 首页特殊处理
    if (currentPath === "/home/index") {
    setSelectedKeys([]);
     setOpenKeys([]);

    if (onMenuSelect) {
     onMenuSelect?.(HOME_TITLE);
   }

    setRefreshKey(+new Date());

   return;
  }
    const menuInfo = matchMenuByPathname(currentPath, selectedItems);
    
    if (menuInfo) {
      setSelectedKeys([menuInfo.key]);
      if (menuInfo.parentKey) {
        setOpenKeys([menuInfo.parentKey]);
      }
     if (onMenuSelect && menuInfo.label) {
   onMenuSelect(menuInfo.label);
  }
      setRefreshKey(+new Date());
      return;
    }
    
    // 降级方案
    const url = location.pathname.split('?')[0];
    const path = url.split('/').filter(p => p);
    
    if (path.length >= 2) {
      setSelectedKeys([path[1]]);
      setOpenKeys([path[0]]);
      setRefreshKey(+new Date());
    } else if (path.length === 1) {
      setSelectedKeys([path[0]]);
      setOpenKeys([]);
      setRefreshKey(+new Date());
    }
  }, [location.pathname, selectedItems]);

  // 渲染菜单函数


  const renderMenuFn = (items = selectedItems, parentPath = '', depth = 0) => {
  if (depth > 5) return null;
  
  return items.map(({ key, label, target = '_self', icon, children, menuUrl }) => {
    const baseUrl = `${window.location.origin}#`
    
    // 获取当前菜单的路径部分
    const pathSegment = menuUrl || key;
    
    // 构建当前菜单的完整路径
    const currentPath = parentPath ? `${parentPath}/${pathSegment}` : `/${pathSegment}`;
    
    // 子菜单的路径基础（用于递归）
    const childParentPath = children?.length ? currentPath : '';
  
    const route = children?.length ? childParentPath : `${baseUrl}${currentPath}`;
    
    const menuInfo = JSON.stringify({
      key: key,
      label: label
    });

    return children?.length ? (
      <Menu.SubMenu key={key} icon={icon} title={label}>
        {renderMenuFn(children, childParentPath, depth + 1)}
      </Menu.SubMenu>
    ) : (
      <Menu.Item key={key} icon={icon}>
        <a
          href={route}
          target={target}
          onClick={() => {
            sessionStorage.setItem('expectedMenu', menuInfo);
          }}
          onContextMenu={() => {
            sessionStorage.setItem('expectedMenu', menuInfo);
          }}
        >
          {label}
        </a>
      </Menu.Item>
    );
  });
};



  return (
    <Sider
      width={270}
      trigger={null}
      collapsible
      collapsed={collapsed}
      className="sideTheme side-sider"
      breakpoint="lg"
      collapsedWidth={0}
      onBreakpoint={(broken) => {
        setCollapsed(broken);
      }}
    >
      <div
        className="logo"
        onClick={() => navigate("/home/index")}
        style={{ cursor: "pointer" }}
      >
        <div className="logo-d">
          <img
            src={logoD}
            width={45}
            height={45}
            alt="D"
            className="logo-img"
          />
        </div>
        <div>
          <div className="logo-dw">
            <img src={DataWorkersLogo} alt="DATAworkers" />
          </div>
          <div className="logo-title">Management Software</div>
        </div>
      </div>

      <div className="divider-line" />

      <Menu
        key={refreshKey}
        theme="light"
        mode="inline"
        className="sideTheme side-menu"
        selectedKeys={selectedKeys}
        defaultSelectedKeys={selectedKeys}
        triggerSubMenuAction="click"
        inlineCollapsed={collapsed}
        onOpenChange={(keys) => !collapsed && setOpenKeys(keys)}
        openKeys={collapsed ? [] : openKeys}
        onSelect={handleMenuSelect}
      >
        {/* {renderMenuFn()} */}
        {renderMenuFn(selectedItems, '')}
      </Menu>
    </Sider>
  );
});

export default SideMenuComponent;